import { render, staticRenderFns } from "./SplitSection.vue?vue&type=template&id=63628deb&scoped=true"
import script from "./SplitSection.vue?vue&type=script&lang=js"
export * from "./SplitSection.vue?vue&type=script&lang=js"
import style0 from "./SplitSection.vue?vue&type=style&index=0&id=63628deb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63628deb",
  null
  
)

export default component.exports